import { Component, inject } from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../service/toast.service';
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [CommonModule,NgbToastModule, NgTemplateOutlet],
  // templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
  template: `
      <ngb-toast
      *ngFor="let toast of toastService?.toasts"
      [class]="toast?.classname"
      [autohide]="true"
      [delay]="toast?.delay || 5000"
      (hidden)="toastService.remove(toast)"
    >
      <!-- <ng-template [ngTemplateOutlet]="toast.template"></ng-template> -->
       {{toast?.content}}
      <div [innerHTML]="setHtmlContent(toast?.content)">
         
      </div>
    </ngb-toast>
 
`,

host: { class: 'toast-container position-fixed bottom-0 end-0 p-3', style: 'z-index: 1200;' },
})
export class ToastsComponent {
  toastService = inject(ToastService);
  _sanitizer = inject(DomSanitizer);

  x:number = 0;

  public setHtmlContent(content:any) :SafeHtml | void{

 
    if(this.x !=1){
      this.x++;
      return this._sanitizer?.bypassSecurityTrustHtml(content);
    }
    // console.log("dsmjsjakk")

   
  }
  
}
